<template>
	<v-tooltip top>
    <v-btn
      slot="activator"
      absolute fab top right small
      class="remove-btn"
      @click="$emit('click')"
    ><v-icon>close</v-icon>
    </v-btn>
    <span>Remove Screenshot from finding</span>
  </v-tooltip>
</template>

<script>
	export default {
    name: 'RemoveFromFindingBtn',

    props: {
      findingIndex: Number,
      imgIndex: Number
    },

    data() {
      return {

      }
    }
  }
</script>